<template>
  <div>
    <Navbar />
    <MainBanner />
    <HelpDesk />
    <Services />
    <WhatWeDo />
    <TechStack />
    <Process />
    <Results />
    <Faq />
    <Subscribe />
    <Partner />
    <Footer />
    <WhatsAppFloat />
  </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import MainBanner from '../ITStartup/MainBanner'
import HelpDesk from '../ITStartup/HelpDesk'
import Services from '../ITStartup/Services'
import WhatWeDo from '../ITStartup/WhatWeDo'
import TechStack from '../ITStartup/TechStack'
import Process from '../ITStartup/Process'
import Results from '../ITStartup/Results'
import Faq from '../ITStartup/Faq'
import Subscribe from '../ITStartup/Subscribe'
import Partner from '../ITStartup/Partner'
import Footer from '../Layouts/Footer'
import WhatsAppFloat from '../Common/WhatsAppFloat'

export default {
  name: 'ITStartupPage',
  components: {
    Navbar,
    MainBanner,
    HelpDesk,
    Services,
    WhatWeDo,
    TechStack,
    Process,
    Results,
    Faq,
    Subscribe,
    Partner,
    Footer,
    WhatsAppFloat,
  }
}
</script>

<style scoped>
/* Global improvements for smooth scrolling and animations */
* {
  scroll-behavior: smooth;
}

/* Add fade-in animation for page load */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

div {
  animation: fadeIn 0.5s ease-in;
}
</style>